"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const Back_vue_1 = __importDefault(require("../../Common/Back.vue"));
const ProgressBar_vue_1 = __importDefault(require("../../Common/ProgressBar.vue"));
// Views
const AreaSelection_vue_1 = __importDefault(require("./components/AreaSelection.vue"));
const UploadFiles_vue_1 = __importDefault(require("./components/UploadFiles.vue"));
const MapView_vue_1 = __importDefault(require("./components/MapView.vue"));
// Services
const trans_1 = require("@common/tsutils/trans");
let GisUploaderView = class GisUploaderView extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.poligonoss = [];
        this.nameMap = '';
        this.stagesProgressBar = [
            {
                id: 0,
                name: (0, trans_1.trans)('gisUploader.views.area'),
                active: true,
                changeActive(value) { },
            },
            {
                id: 1,
                name: (0, trans_1.trans)('gisUploader.views.files'),
                active: false,
                changeActive(value) { },
            },
            {
                id: 2,
                name: (0, trans_1.trans)('gisUploader.views.map'),
                active: false,
                changeActive(value) { },
            },
        ];
        this.viewActive = 0; // 0 -> AreaSelection, 1 -> UploadFiles, 2 -> Map
    }
    configMap(poligonos, name) {
        this.poligonoss = poligonos;
        this.nameMap = name;
    }
    setView(value) {
        if (value === 'AreaSelection')
            this.viewActive = 0;
        if (value === 'UploadFiles')
            this.viewActive = 1;
        if (value === 'Map')
            this.viewActive = 2;
    }
    setLocations(value) {
        this.location = value;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
    // @ts-ignore
], GisUploaderView.prototype, "vuedata", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], GisUploaderView.prototype, "map_config", void 0);
GisUploaderView = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Back: Back_vue_1.default,
            ProgressBar: ProgressBar_vue_1.default,
            AreaSelection: AreaSelection_vue_1.default,
            UploadFiles: UploadFiles_vue_1.default,
            MapView: MapView_vue_1.default,
        },
    })
], GisUploaderView);
exports.default = GisUploaderView;
